import { HttpClient, HttpParams } from '@angular/common/http';
import { CATCH_ERROR_VAR } from '@angular/compiler/src/output/output_ast';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-portmaster',
  templateUrl: './portmaster.component.html',
  styleUrls: ['./portmaster.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class PortmasterComponent implements OnInit {

  PortName: string;
  PortCode: string;
  Type: string;
  Address1: string;
  Address2: string;
  City: string;
  State: string;
  Country: string;
  zip: string;
  Description: string;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean = true;
  isShownActive: Boolean = true;
  public searchText: string;
  PortExport = [] as any;
  EditedPort = [] as any;
  EditedPortId: string;
  countrys = [];
  countryid: string;
  countrycode: string;
  Status: boolean = false;
  str1: string; str2: string; str3:string; str4 : string; str5 : string; str: string;
  cntname: string;
  alphacheck: string;
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;

  displayedColumns: string[] = ['sno', 'portcode', 'portname', 'portType', 'address1', 'city', 'country', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('PortRead');
    this.vWrite = localStorage.getItem('PortWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }

    this.BindPortGrid();
    this.BindPortExport();
    this.BindCountryDDL();
  }

  Show(event: any) {
    var cportcode = this.PortCode;
    if (cportcode != undefined || cportcode == "" || cportcode == null) {
      var prtcode = cportcode.split("");
      this.str1 = prtcode[0];
      this.str2 = prtcode[1];
      this.str = this.str1 + "" + this.str2;     
    }
    let params = new HttpParams();
    params = params.append('dcntcode', this.str);
    var value = this.http.get(environment.apiUrl + 'Port/CheckCountry', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed" || vErrorMsg1 =="") {
          this.isShownError = false;
          this.ErrorMsg = "Country doesn't Exist,Please Enter a valid port code.";
          this.Country = "";
          return false;
        }
        else {
        }       
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed" || vErrorMsg1 == "") {
          this.isShownError = false;
          this.ErrorMsg = "Country doesn't Exist,Please Enter a valid port code."
          this.Country="";
          return false;
        }
        else {
          this.Country = vErrorMsg1;
        }   
      });
  }


  BindCountryDDL() {
    var value = this.http.get(environment.apiUrl + 'Port/GetCountryDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.countrys = data;
          this.countryid = "0";
        }
        else {
        };
      });
  }

  SubmitPort() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vportcode = this.PortCode;
    var vportname = this.PortName;
    var vType = this.Type;
    var vAddress1 = this.Address1;
    var vAddress2 = this.Address2;
    var vCity = this.City;
    var vState = this.State;
    var vcountry = this.Country;
    var vzip = this.zip;
    var vDescription = this.Description;
    debugger;



    if (vportcode == undefined || vportcode == "" || vportcode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Port Code.";
      return false;
    }

    var cportcode = this.PortCode;
    if (cportcode != undefined || cportcode == "" || cportcode == null) {
      var prtcode = cportcode.split("");
      for(var i=0 ;i<prtcode.length;i++)      
      {        
        if(i==5 || i ==6)
        {}
        else if (!(prtcode[i] >= 'a' && prtcode[i] <= 'z' || prtcode[i] >= 'A' && prtcode[i] <= 'Z')) {
          this.isShownError = false;
          this.ErrorMsg = "Please Enter valid Port Code.";
          return false;
        }
      }      
    }

    if (vportname == undefined || vportname == "" || vportname == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Port Name.";
      return false;
    }
    if (vType == undefined || vType == "" || vType == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Port Type.";
      return false;
    }
    if (vAddress1 == undefined || vAddress1 == "" || vAddress1 == "0") {
      this.Address1 = "";
    }
    if (vAddress2 == undefined || vAddress2 == "" || vAddress2 == "0") {
      this.Address2 = "";
    }
    if (vCity == undefined || vCity == "" || vCity == "0") {
      this.City = "";
    }
    if (vState == undefined || vState == "" || vState == "0") {
      this.State = "";
    }
    if (vcountry == undefined || vcountry == "" || vcountry == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Country.";
      return false;
    }
    if (vzip == undefined || vzip == "" || vzip == "0") {
      this.zip = "";
    }
    if (vDescription == undefined || vDescription == "" || vDescription == "0") {
      this.Description = "";
    }

    let params = new HttpParams();
    params = params.append('dportcode', this.PortCode);
    params = params.append('dportname', this.PortName);
    params = params.append('dportType', this.Type);
    params = params.append('dAddress1', this.Address1);
    params = params.append('dAddress2', this.Address2);
    params = params.append('dCity', this.City);
    params = params.append('dState', this.State);
    params = params.append('dcountry', this.Country);
    params = params.append('dzip', this.zip);
    params = params.append('dDescription', this.Description);

    var value = this.http.get(environment.apiUrl + 'Port/InsertPort', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var PortCode = data;
        this.PortCode = "";
        this.PortName = "";
        this.Type = "";
        this.Address1 = "";
        this.Address2 = "";
        this.State = "";
        this.City = "";
        this.zip = "";
        this.Country = "";
        this.Description = "";
        this.SuccessMsg = "PortMaster Added."
        this.BindPortExport();
        this.BindPortGrid();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Port Code Already Exist.";
          return false;
        }
        else {
        }
      });
  }

  ClearPort() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
    this.isShownActive = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.PortCode = "";
    this.PortName = "";
    this.Type = "";
    this.Address1 = "";
    this.Address2 = "";
    this.State = "";
    this.City = "";
    this.zip = "";
    this.Country = "";
    this.Description = "";

  }

  EditPort(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.EditedPort = item;
    var vportid = this.EditedPort.portid;
    var vportcode = this.EditedPort.portcode;
    var vportname = this.EditedPort.portname;
    var vportType = this.EditedPort.portType;
    var vaddress = this.EditedPort.address1;
    var vcity = this.EditedPort.city;
    var vDescription = this.EditedPort.description;
    var vstate = this.EditedPort.state;
    var vpin = this.EditedPort.pin;
    var vcountry = this.EditedPort.country;
    var vstatus = this.EditedPort.status;

    this.EditedPortId = vportid;
    this.PortCode = vportcode;
    this.PortName = vportname;
    this.Type = vportType;
    this.Address1 = vaddress;
    this.City = vcity;
    this.Country = vcountry;
    this.State = vstate;
    this.Description = vDescription;
    this.zip = vpin;
    var vstatus = this.EditedPort.status;
    debugger;
    if (vstatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }


  }

  UpdatePort() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.isShownActive = false;

    var vportcode = this.PortCode;
    var vportname = this.PortName;
    var vType = this.Type;
    var vAddress1 = this.Address1;
    var vAddress2 = this.Address2;
    var vCity = this.City;
    var vState = this.State;
    var vcountry = this.Country;
    var vzip = this.zip;
    var vDescription = this.Description;
    debugger;

    if (vportcode == undefined || vportcode == "" || vportcode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Port Code.";
      return false;
    }
    var cportcode = this.PortCode;
    if (cportcode != undefined || cportcode == "" || cportcode == null) {
      var prtcode = cportcode.split("");
      for(var i=0 ;i<prtcode.length;i++)      
      {        
        if(i==5 || i ==6)
        {}
        else if (!(prtcode[i] >= 'a' && prtcode[i] <= 'z' || prtcode[i] >= 'A' && prtcode[i] <= 'Z')) {
          this.isShownError = false;
          this.ErrorMsg = "Please Enter valid Port Code.";
          return false;
        }
      }      
    }
    if (vportname == undefined || vportname == "" || vportname == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Port Name.";
      return false;
    }
    if (vType == undefined || vType == "" || vType == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Port Type.";
      return false;
    }
    if (vAddress1 == undefined || vAddress1 == "" || vAddress1 == "0") {
      this.Address1 = "";
    }
    if (vAddress2 == undefined || vAddress2 == "" || vAddress2 == "0") {
      this.Address2 = "";
    }
    if (vCity == undefined || vCity == "" || vCity == "0") {
      this.City = "";
    }
    if (vState == undefined || vState == "" || vState == "0") {
      this.State = "";
    }
    if (vcountry == undefined || vcountry == "" || vcountry == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Country.";
      return false;
    }
    if (vzip == undefined || vzip == "" || vzip == "0") {
      this.zip = "";
    }
    if (vDescription == undefined || vDescription == "" || vDescription == "0") {
      this.Description = "";
    }

    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    debugger;
    let params = new HttpParams();
    params = params.append('iPortid', this.EditedPortId);
    params = params.append('iportcode', this.PortCode);
    params = params.append('iportname', this.PortName);
    params = params.append('iportType', this.Type);
    params = params.append('iAddress1', this.Address1);
    params = params.append('iAddress2', this.Address2);
    params = params.append('iCity', this.City);
    params = params.append('iState', this.State);
    params = params.append('icountry', this.Country);
    params = params.append('izip', this.zip);
    params = params.append('iDescription', this.Description);
    params = params.append('istatus', vStatus);
    debugger;
    var value = this.http.get(environment.apiUrl + 'Port/UpdatePort', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var Portscode = data;
        this.PortCode = "";
        this.PortName = "";
        this.Type = "";
        this.Address1 = "";
        this.Address2 = "";
        this.State = "";
        this.City = "";
        this.zip = "";
        this.Country = "";
        this.Description = "";
        this.SuccessMsg = "PortMaster Updated."
        this.BindPortExport();
        this.BindPortGrid();
        this.isShownSaveBtn = false;
        this.isShownUpdateBtn = true;
        this.isShownActive = true;
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });
  }

  async BindPortGrid() {
    debugger;
    var value = await this.http.get(environment.apiUrl + 'Port/GetPortForGrid').toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindPortExport() {
    var value = this.http.get(environment.apiUrl + 'Port/GetPortForExport').toPromise().then(
      (data: any) => {
        debugger;
        this.PortExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.PortExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'Port');

    /* save to file */
    XLSX.writeFile(wb, "Port.xlsx");

  }



}
